import { Flame } from "lucide-react";
import { ENGINES } from "../../lib/constants";

export default function Engines() {
  return (
    <section
      id="engines"
      data-testid="engines-section"
      className="relative bg-[#0B1D3A] py-24 lg:py-32 overflow-hidden"
    >
      {/* Decorative grid */}
      <div
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage:
            "linear-gradient(to right, rgba(255,255,255,0.06) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,0.06) 1px, transparent 1px)",
          backgroundSize: "48px 48px",
        }}
      />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="mb-14">
          <h2 className="font-display font-bold text-white text-3xl sm:text-4xl lg:text-5xl leading-[1.08] tracking-tight max-w-3xl">
            Engines
            <br />
            <span className="text-[#C9A961]">We Support.</span>
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {ENGINES.map((eng) => (
            <div
              key={eng.oem}
              data-testid={`engine-${eng.oem.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="group bg-white/[0.04] border border-white/15 rounded-sm overflow-hidden hover:border-[#C9A961] hover:-translate-y-1 transition-all duration-300"
            >
              <div className="p-6 border-b border-white/10 flex items-center justify-between">
                <div>
                  <p className="text-[10px] uppercase tracking-[0.22em] text-[#C9A961] font-semibold mb-1.5">
                    Engine OEM
                  </p>
                  <h3 className="font-display font-bold text-white text-lg leading-tight">
                    {eng.oem}
                  </h3>
                </div>
                <div className="w-11 h-11 border border-[#C9A961]/40 bg-[#C9A961]/10 flex items-center justify-center rounded-sm flex-shrink-0">
                  <Flame className="w-4 h-4 text-[#C9A961]" />
                </div>
              </div>

              <div className="p-6 space-y-5">
                {eng.families.map((fam) => (
                  <div key={fam.title}>
                    <p className="font-display font-semibold text-white text-sm mb-2.5 tracking-tight">
                      {fam.title}
                    </p>
                    <div className="flex flex-wrap gap-1.5">
                      {fam.models.map((m) => (
                        <span
                          key={m}
                          className="inline-block font-mono text-[11px] tracking-tight bg-[#0B1D3A] border border-white/15 text-white/85 px-2.5 py-1 rounded-sm hover:border-[#C9A961] hover:text-[#C9A961] transition-colors"
                        >
                          {m}
                        </span>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
